import { motion } from "framer-motion";
import { Lock, BarChart3, Save, Zap, ShieldCheck, ArrowRight, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageLayout } from "@/components/layout/PageLayout";
import { useState } from "react";

const Portal = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubmitted(true);
      setEmail("");
    }
  };

  const features = [
    { icon: BarChart3, text: "Dashboard personal cu scor SEO & GEO în timp real" },
    { icon: Save, text: "Salvează și monitorizează proiecte multiple" },
    { icon: Zap, text: "Activează optimizări automate controlate" },
    { icon: ShieldCheck, text: "Optimizare garantată timp de 30 zile" },
  ];

  return (
    <PageLayout>
      <section className="py-20 md:py-32">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-2xl mx-auto text-center"
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent border border-primary/20 mb-8">
              <Lock className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-accent-foreground">Coming Soon</span>
            </div>

            <h1 className="text-3xl md:text-5xl font-bold text-foreground leading-tight mb-6">
              Portalul OptiRO.ai va fi disponibil la{" "}
              <span className="text-gradient">lansarea oficială (Mijlocul 2026)</span>
            </h1>

            <p className="text-lg text-muted-foreground mb-10">
              În versiunea completă, vei putea:
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-12 text-left max-w-lg mx-auto">
              {features.map((f, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 * i }}
                  className="flex items-start gap-3 p-3 rounded-lg bg-muted/50"
                >
                  <f.icon className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-foreground">{f.text}</span>
                </motion.div>
              ))}
            </div>

            <div className="card-elevated p-8 max-w-md mx-auto">
              <p className="text-foreground font-medium mb-4">
                👉 Înscrie-te pentru acces prioritar și oferta de lansare.
              </p>

              {submitted ? (
                <div className="flex items-center justify-center gap-2 text-primary py-4">
                  <ShieldCheck className="w-5 h-5" />
                  <span className="font-medium">Te-ai înscris cu succes!</span>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
                  <Input
                    type="email"
                    placeholder="email@exemplu.ro"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="flex-1"
                    required
                  />
                  <Button type="submit" className="whitespace-nowrap">
                    <Mail className="w-4 h-4 mr-2" />
                    Primește update-urile
                  </Button>
                </form>
              )}
            </div>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Portal;
